/**
 * jzn-promo.js — попъпът за откриването на магазина („−5% с код JIZNEN5").
 *
 * Негово искане (01.09.2026): банер с код за отстъпка 5% за откриването,
 * за ВСИЧКИ продукти БЕЗ тези на New Era (там маржът е нула).
 *
 * Правилата за показване са неговите, дума по дума:
 *   · излиза СЛЕД 10 секунди — човекът първо вижда магазина, после получава кода;
 *   · веднъж на посетител, НО „ако го е затворил, без да иска" не бива да го
 *     губи завинаги → затвори ли го, се връща чак на СЛЕДВАЩО посещение (най-рано
 *     след 24 часа) и най-много три пъти общо;
 *   · „на този, който го е ползвал, да не му излиза" → копира ли кода, мълчи 7
 *     дни; направи ли поръчка, спира завинаги.
 *
 * Всичко живее в БРАУЗЪРА на човека (localStorage) — нищо не тръгва към нас.
 * Файлът е отделен от `jzn-delivery.js` нарочно: касата е сериозна работа и не
 * бива да дели съдба с един банер.
 */
(function () {
  'use strict';

  var КОД = 'JIZNEN5';
  var ПРОЦЕНТ = 5;
  var ДО = '1 октомври';
  var БЕЗ = 'New Era';
  var ЗАБАВЯНЕ = 10000;          // 10 секунди
  var МАКСИМУМ = 3;              // повече от три пъти е досада
  var ПАУЗА_ЗАТВОРЕН = 24 * 3600 * 1000;
  var ПАУЗА_КОПИРАН = 7 * 24 * 3600 * 1000;
  var КЛЮЧ = 'jzn_promo_v1';

  // --- памет ---------------------------------------------------------------
  function памет() {
    try { return JSON.parse(localStorage.getItem(КЛЮЧ) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function запиши(п) {
    try { localStorage.setItem(КЛЮЧ, JSON.stringify(п)); } catch (e) { /* без памет — просто не помним */ }
  }

  /** ЧИСТО: показва ли се сега? Всяко „не" има своя причина. */
  function бива(п, сега) {
    if (п.използван) return false;                                   // вече е поръчал
    if ((п.показвания || 0) >= МАКСИМУМ) return false;
    if (п.копиранНа && сега - п.копиранНа < ПАУЗА_КОПИРАН) return false;
    if (п.затворенНа && сега - п.затворенНа < ПАУЗА_ЗАТВОРЕН) return false;
    return true;
  }

  /** Касата и количката не се прекъсват с банер. */
  function неможеТук() {
    var p = (location.pathname || '').toLowerCase();
    return p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/account') === 0;
  }

  // --- вид -----------------------------------------------------------------
  var СТИЛ = [
    '.jzn-promo-bg{position:fixed;inset:0;background:rgba(12,20,15,.45);z-index:9998;opacity:0;transition:opacity .25s}',
    '.jzn-promo-bg.on{opacity:1}',
    '.jzn-promo{position:fixed;z-index:9999;left:50%;top:50%;transform:translate(-50%,-46%);width:min(92vw,420px);',
    'background:#fff;border-radius:14px;box-shadow:0 18px 50px rgba(0,0,0,.28);padding:28px 26px 22px;',
    'font-family:-apple-system,Segoe UI,Roboto,sans-serif;color:#16211a;opacity:0;transition:opacity .25s,transform .25s}',
    '.jzn-promo.on{opacity:1;transform:translate(-50%,-50%)}',
    '.jzn-promo h2{margin:0 0 6px;font-size:21px;line-height:1.25;font-weight:700;color:#16211a}',
    '.jzn-promo p{margin:0 0 16px;font-size:15px;line-height:1.5;color:#41504a}',
    '.jzn-promo .code{display:flex;align-items:center;justify-content:center;gap:10px;border:2px dashed #2f6b3f;',
    'border-radius:10px;padding:13px 10px;font-size:23px;font-weight:700;letter-spacing:2px;color:#2f6b3f;background:#f4f9f5}',
    '.jzn-promo button.copy{margin-top:14px;width:100%;padding:13px;border:0;border-radius:8px;background:#2f6b3f;color:#fff;',
    'font-size:15px;font-weight:600;cursor:pointer;font-family:inherit}',
    '.jzn-promo button.copy:hover{background:#265733}',
    '.jzn-promo .fine{margin:12px 0 0;font-size:12px;line-height:1.45;color:#7c8a83;text-align:center}',
    '.jzn-promo .x{position:absolute;top:8px;right:10px;border:0;background:none;font-size:26px;line-height:1;',
    'color:#9aa5a0;cursor:pointer;padding:4px 8px;font-family:inherit}',
    '.jzn-promo .x:hover{color:#41504a}',
    '@media(max-width:600px){.jzn-promo{top:auto;bottom:0;left:0;transform:translateY(100%);width:100%;',
    'border-radius:14px 14px 0 0;padding:24px 20px 20px}.jzn-promo.on{transform:translateY(0)}}',
  ].join('');

  function стил() {
    if (document.getElementById('jzn-promo-css')) return;
    var s = document.createElement('style');
    s.id = 'jzn-promo-css';
    s.textContent = СТИЛ;
    document.head.appendChild(s);
  }

  var отворен = null;

  function затвори(причина) {
    if (!отворен) return;
    var п = памет();
    if (причина === 'копиран') {
      п.копиранНа = Date.now();
      /**
       * Кодът се помни САМО след като човекът натисне „Копирай кода".
       *
       * Негово (01.09.2026): „по-добре, ако има реакция от страна на клиента".
       * Първо се запомняше в мига на ПОКАЗВАНЕТО — тоест касата слагаше
       * отстъпка на всеки, който просто е видял прозорчето и го е затворил.
       * Отстъпката е за този, който я е поискал.
       */
      п.код = КОД;
    } else {
      п.затворенНа = Date.now();
    }
    запиши(п);
    отворен.бг.classList.remove('on');
    отворен.кутия.classList.remove('on');
    var о = отворен; отворен = null;
    setTimeout(function () {
      if (о.бг.parentNode) о.бг.parentNode.removeChild(о.бг);
      if (о.кутия.parentNode) о.кутия.parentNode.removeChild(о.кутия);
    }, 260);
    document.removeEventListener('keydown', приКлавиш);
  }

  function приКлавиш(e) { if (e.key === 'Escape') затвори('затворен'); }

  function копирай(бутон) {
    function успех() {
      бутон.textContent = 'Копирано ✓';
      setTimeout(function () { затвори('копиран'); }, 900);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(КОД).then(успех, ръчно);
        return;
      }
    } catch (e) { /* пада на ръчното */ }
    ръчно();
    function ръчно() {
      // Стар браузър или отказан достъп до клипборда: селектираме текста, за да
      // може човекът да го копира сам. По-добре от бутон, който нищо не прави.
      try {
        var t = document.createElement('textarea');
        t.value = КОД; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select(); document.execCommand('copy');
        document.body.removeChild(t);
        успех();
      } catch (e2) { бутон.textContent = 'Кодът е ' + КОД; }
    }
  }

  function покажи() {
    if (отворен || неможеТук()) return;
    стил();

    var бг = document.createElement('div');
    бг.className = 'jzn-promo-bg';
    /**
     * 🪤 Негово, 01.09.2026: „на телефон, ако цъкнеш някъде другаде, попъпът
     * изчезва и трябва да върнеш назад, за да видиш кода". Затова щракването
     * встрани вече НЕ затваря — затваря се само с × (или с Esc на компютър).
     */

    var к = document.createElement('div');
    к.className = 'jzn-promo';
    к.setAttribute('role', 'dialog');
    к.setAttribute('aria-modal', 'true');
    к.setAttribute('aria-label', 'Код за отстъпка за откриването');

    var x = document.createElement('button');
    x.className = 'x'; x.type = 'button'; x.textContent = '×';
    x.setAttribute('aria-label', 'Затвори');
    x.addEventListener('click', function () { затвори('затворен'); });

    var h = document.createElement('h2');
    h.textContent = 'Отваряме магазина';
    var p = document.createElement('p');
    p.textContent = 'Вземи −' + ПРОЦЕНТ + '% от поръчката си с този код:';

    var code = document.createElement('div');
    code.className = 'code'; code.textContent = КОД;

    var b = document.createElement('button');
    b.className = 'copy'; b.type = 'button'; b.textContent = 'Копирай кода';
    b.addEventListener('click', function () { копирай(b); });

    var fine = document.createElement('p');
    fine.className = 'fine';
    fine.textContent = 'Важи до ' + ДО + '. Не важи за продуктите на ' + БЕЗ + '.';

    к.appendChild(x); к.appendChild(h); к.appendChild(p);
    к.appendChild(code); к.appendChild(b); к.appendChild(fine);
    document.body.appendChild(бг); document.body.appendChild(к);

    // Един кадър по-късно, за да има какво да се анимира.
    requestAnimationFrame(function () { бг.classList.add('on'); к.classList.add('on'); });
    document.addEventListener('keydown', приКлавиш);
    отворен = { бг: бг, кутия: к };

    var п = памет();
    п.показвания = (п.показвания || 0) + 1;
    п.последноНа = Date.now();
    запиши(п);
  }

  /**
   * „Ползвал го е" = направил е поръчка.
   *
   * Не пипаме `jzn-delivery.js` заради това — гледаме екрана „Благодарим",
   * който тя рисува в своя дом (`#jzn-delivery-host`, елемент с клас `thx`).
   */
  function следиЗаПоръчка() {
    if (!window.MutationObserver || !document.body) return;
    // ⚠️ Домът на касата (`#jzn-delivery-host`) го НЯМА при зареждане — ражда се
    // чак когато човекът отвори касата. Затова се гледа цялото тяло, не той.
    var о = new MutationObserver(function () {
      if (!document.querySelector('#jzn-delivery-host .thx')) return;
      var п = памет(); п.използван = true; запиши(п);
      о.disconnect();
      затвори('използван');
    });
    о.observe(document.body, { childList: true, subtree: true });
  }

  function старт() {
    следиЗаПоръчка();
    if (!бива(памет(), Date.now())) return;
    setTimeout(покажи, ЗАБАВЯНЕ);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', старт);
  else старт();
})();
